export function scrollToAnchor() {
    setTimeout(() => {
        const anchor = window.location.hash;
        if (!anchor) return;
        const element = document.querySelector(anchor);
        element.scrollIntoView({ behavior: "smooth" });
    }, 100);
}
